module.exports = __webpack_public_path__ + "static/media/default-audiocall.e90d2169.png";